import { createTheme } from '@mui/material/styles';
import { COLORS, SHADOWS } from './tokens';

/**
 * MUI 主题配置
 * 主色 #E53935（品牌红），辅色 #1976D2（蓝）
 * 字体：PingFang SC, Microsoft YaHei
 * 圆角 8px
 */
export const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary,
      light: COLORS.primaryLight,
      dark: COLORS.primaryDark,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: COLORS.secondary,
      light: COLORS.secondaryLight,
      dark: COLORS.secondaryDark,
      contrastText: '#FFFFFF',
    },
    success: {
      main: COLORS.success,
      contrastText: '#FFFFFF',
    },
    warning: {
      main: COLORS.warning,
      contrastText: '#FFFFFF',
    },
    info: {
      main: COLORS.info,
      contrastText: '#FFFFFF',
    },
    error: {
      main: COLORS.error,
      contrastText: '#FFFFFF',
    },
    text: {
      primary: COLORS.textPrimary,
      secondary: COLORS.textSecondary,
      disabled: COLORS.textDisabled,
    },
    background: {
      default: COLORS.backgroundDefault,
      paper: COLORS.backgroundPaper,
    },
    divider: COLORS.border,
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily:
      '"PingFang SC", "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif',
    h1: { fontSize: '28px', fontWeight: 700, lineHeight: 1.3 },
    h2: { fontSize: '20px', fontWeight: 700, lineHeight: 1.4 },
    h3: { fontSize: '16px', fontWeight: 600, lineHeight: 1.5 },
    body1: { fontSize: '14px', fontWeight: 400, lineHeight: 1.6 },
    body2: { fontSize: '13px', fontWeight: 400, lineHeight: 1.5 },
    caption: { fontSize: '12px', fontWeight: 400, lineHeight: 1.4 },
    button: { fontSize: '14px', fontWeight: 600, lineHeight: 1.5 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 6,
          padding: '8px 20px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: SHADOWS.card,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '12px 16px',
          fontSize: '14px',
          color: COLORS.textPrimary,
        },
        head: {
          backgroundColor: COLORS.tableHeader,
          color: COLORS.textSecondary,
          fontWeight: 600,
          fontSize: '14px',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: 56,
          '&:hover': {
            backgroundColor: COLORS.tableHover,
          },
        },
      },
    },
  },
});
